import React from 'react';
import { Container } from '../../common/base';
import { Grid, Col } from '../../common/interfaces';
import { withTranslation } from '../../common/libs/i18n';
import { FeatureWrapper, FeatureItem, FeatureItemIcon, FeatureItemDesc } from './Styled';

const features = [
  {
    image: '../../static/images/feature/ic-stable.svg',
    title: ({ t }) => t('landing.feature.stable.title', 'Stable'),
    text: ({ t }) =>
      t(
        'landing.feature.stable.description',
        'All IDRT is backed 1:1 by Rupiah that is stored in reserve. As a result, the price of each token is stable at one Rupiah'
      )
  },
  {
    image: '../../static/images/feature/ic-reliable.svg',
    title: ({ t }) => t('landing.feature.reliable.title', 'Reliable'),
    text: ({ t }) =>
      t(
        'landing.feature.reliable.description',
        'IDRT leverages the world-renowned security and transparency of the Ethereum Blockchain'
      )
  },
  {
    image: '../../static/images/feature/ic-secure.svg',
    title: ({ t }) => t('landing.feature.secure.title', 'Secure'),
    text: ({ t }) =>
      t(
        'landing.feature.secure.description',
        'Our IDRT Smart Contract has been audited by CertiK. You can find our certificate at the bottom of this website'
      )
  },
  {
    image: '../../static/images/feature/ic-fast.svg',
    title: ({ t }) => t('landing.feature.fast.title', 'Fast & Borderless'),
    text: ({ t }) =>
      t(
        'landing.feature.fast.description',
        'You can send IDRT to anyone, anytime, and anywhere within minutes, thanks to the speed of Ethereum Blockchain'
      )
  },
  {
    image: '../../static/images/feature/ic-trusted.svg',
    title: ({ t }) => t('landing.feature.trusted.title', 'Trusted'),
    text: ({ t }) =>
      t(
        'landing.feature.trusted.description',
        'The reserve of Rupiah that backs IDRT is audited every month by a financial partner, ensuring its redeemability'
      )
  },
  {
    image: '../../static/images/feature/ic-accessible.svg',
    title: ({ t }) => t('landing.feature.accessible.title', 'Accessible'),
    text: ({ t }) =>
      t(
        'landing.feature.accessible.description',
        'As an ERC-20 token built on Ethereum, IDRT can be easily integrated with any ERC-20 compliant services'
      )
  }
];

const HomeFeature = props => (
  <FeatureWrapper>
    <Container>
      <Grid>
        {features.map((feature, index) => (
          <Col key={index} lg={4} md={6} sm={12}>
            <FeatureItem>
              <FeatureItemIcon alt="" src={feature.image} />
              <FeatureItemDesc>
                <h2>{feature.title(props)}</h2>
                <p>{feature.text(props)}</p>
              </FeatureItemDesc>
            </FeatureItem>
          </Col>
        ))}
      </Grid>
    </Container>
  </FeatureWrapper>
);

export default withTranslation('common')(HomeFeature);
